module.exports = __webpack_public_path__ + "static/Calibre-Medium-88178c3f2a309ad11520ee62765072d0.ttf";